import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@core/security/services/auth.service';
import { map, Observable, tap } from 'rxjs';
import { CookiesService } from '~shared/services/coookies.service';
import { expiredCodeSumax, InterceptStrategy } from './InterceptStrategy';

@Injectable({ providedIn: 'root' })
export class SumaxErpInterceptStrategy implements InterceptStrategy {

	isRefreshToken = true;

	endpoints = ['sumax-erp-backend-maestros', 'sumax-erp-backend-security', 'sumax-erp-backend-config', 'sumax-erp-backend-documentos-operativos'];

	secureUrls = ['/api/security/login', '/api/security/first-reset-password', '/api/security/change-password', '/api/security/refresh-token', '/api/security/signout'];

	constructor(private cookiesService: CookiesService, private authService: AuthService) {}

	isIntercepted(req: HttpRequest<any>): boolean {
		if (this.secureUrls.some((url) => req.url.includes(url))) {
			return false;
		}

		return this.endpoints.some((path) => req.url.includes(path));
	}

	getHttpRequest(req: HttpRequest<any>): HttpRequest<any> {
		return req.clone({
			setHeaders: {
				Authorization: this.cookiesService.getBearerAuthorization('idToken'),
			},
		});
	}

	isPosibleTokenExpired(error: HttpErrorResponse): boolean {
		return error.status === 403 && error.error && expiredCodeSumax.includes(error.error.codigo);
	}

	refreshToken(): Observable<Record<string, unknown>> {
		return this.authService.refreshToken().pipe(
			tap((res) => this.authService.updateTokens(res.idToken!, res.accessToken!, res.maestroSyncToken!)),

			map(() => ({}))
		);
	}
}
